module.exports = __webpack_public_path__ + "img/shouch_liwu.23d944eb.png";